import React from 'react'

export const ChevronRight = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="20"
      transform="translate(0 0.621582)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.2112 4.8019C8.4798 4.55007 8.9017 4.56368 9.15352 4.8323L14.1535 10.1656C14.3939 10.4221 14.3939 10.8211 14.1535 11.0775L9.15352 16.4109C8.9017 16.6795 8.4798 16.6931 8.2112 16.4413C7.94259 16.1894 7.92898 15.7675 8.1808 15.499L12.7533 10.6216L8.1808 5.74422C7.92898 5.4756 7.94259 5.05371 8.2112 4.8019Z"
      fill="#3E3E47"
    />
  </svg>
)

export default ChevronRight
